const LoadingSpinner = ({ spinnerType = 'graph', message = 'Loading...', style = {} }) => {
  return (
    <div
      className="fixed inset-0 flex items-center justify-center"
      style={{
        backgroundColor: 'rgba(255, 255, 255, 0.8)',
        zIndex: 9999,
        ...style,
      }}
    >
      <div className="flex items-center space-x-4">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600"></div>
        <p className="text-gray-600 font-bold">{message}</p>
      </div>
    </div>
  );
};

export default LoadingSpinner;
